import { BCardText } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBCardText = createEgBootstrapProxy("EgBCardText", BCardText);
